import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewHostIndividualpageNews from "../../components/HostIndividual/ViewHostIndividualPageNew";



const ViewHostIndividualPage= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Host Individual" title2="Host Individual" link2="/host-individual" />

        {/* AddUserLayer */}
        <ViewHostIndividualpageNews />


      </MasterLayout>
    </>
  );
};

export default ViewHostIndividualPage;
